import { useState } from "react";
import { DownOutlined, RightOutlined, StarFilled } from "@ant-design/icons";
import MarkerSmall from "./MarkerSmall";

const DayViewMapLegend = () => {
  const [legendOpen, setLegendOpen] = useState(true);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '20px',
        right: '10px',
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '12px',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        zIndex: 1,
        fontSize: '12px',
        minWidth: '150px'
      }}
    >
      <div
        style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none', marginBottom: '10px' }}
        onClick={() => setLegendOpen(!legendOpen)}
      >
        {legendOpen ? (
          <DownOutlined style={{ fontSize: '12px' }} />
        ) : (
          <RightOutlined style={{ fontSize: '12px' }} />
        )}
        <span style={{ fontWeight: 600 }}>Legend</span>
      </div>
      {legendOpen && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <MarkerSmall color="#d9d9d9" borderColor="#d9d9d9" statusBadgeColor="#1890ff" />
            <span>Planned</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <MarkerSmall color="#d9d9d9" borderColor="#d9d9d9" statusBadgeColor="#52c41a" />
            <span>Clocked-In</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <MarkerSmall color="#d9d9d9" borderColor="#d9d9d9" statusBadgeColor="#8c8c8c" />
            <span>Visited</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <MarkerSmall color="#CCCCCC" borderColor="#000" icon={<StarFilled style={{ color: '#000', fontSize: '8px' }} />} hideTail />
            <span>Shop</span>
          </div>
        </>
      )}
    </div>
  );
};

export default DayViewMapLegend;